<template>
    <div>
        <slot name="activator" v-bind:show="doShowDialog" v-if="$scopedSlots.activator" />
        <v-btn
            v-else
            @click.stop="showDialog = true"
            text
            color="zoezi-edit-color"
        >
            {{ $translate('Edit redirect list') }}
        </v-btn>

        <v-dialog
            v-model="showDialog"
            :max-width="redirectDialogWidth"
            scrollable
            persistent
        >
            <v-card ref="card">
                <v-card-title class="headline zoezi-edit-color">
                    {{ $translate('Edit redirect list') }}
                    <v-spacer />
                    <v-btn
                        icon
                        @click="showDialog = false"
                        class="zoezi-edit-color"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <p>
                        <a href="https://docs.netlify.com/routing/redirects/redirect-options/" target="_blank">{{ $translate('Redirect file syntax') }}</a>
                    </p>
                    <codemirror
                        v-model="redirects"
                        :options="editorOptions"
                        class="redirect-editor"
                        ref="editor"
                        :style="{ height: editorHeight + 'px' }"
                    />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="zoezi-edit-color"
                        @click="save"
                    >
                        {{ $translate('Save') }}
                    </v-btn>
                    <v-btn @click="showDialog = false">{{ $translate('Close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'

export default {
    name: "zoezi-redirect-setting",
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        showDialog: false,
        redirects: "",
        editorOptions: {
            mode: "text/plain",
            lineNumbers: true,
            lineWrapping: true,
            matchBrackets: true,
            tabSize: 4,
        },
        editorHeight: 300,
    }),
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.redirects = newVal;
            },
        },
        showDialog: {
            handler(newVal) {
                if (newVal) {
                    this.refreshEditorWithDelay();
                }
            },
        },
    },
    methods: {
        save() {
            if (this.validateRedirects(this.redirects)) {
                this.$emit("input", this.redirects);
                this.showDialog = false;
            } else {
                this.$store.commit('showSnackBar', {text: this.$translate('Invalid redirect list. Check syntax.'), color: 'error'});
            }
        },
        validateRedirects(redirects) {
            const lines = redirects.split("\n").map(line => line.trim());
            const redirectRegex = /^\/\S*(\s+(\w+=:\w+))*(\s+\S+)(\s+(301|302))?\s*$/;

            for (const line of lines) {
                if (!line || line.startsWith("#")) {
                    // Allow empty lines and comments
                    continue;
                }
                if (!redirectRegex.test(line)) {
                    return false;
                }
            }
            return true;
        },
        refreshEditorWithDelay() {
            setTimeout(() => {
                this.refreshEditor();
            }, 500);
        },
        refreshEditor() {
            if (this.$refs?.card?.$el) {
                const cardRect = this.$refs.card.$el.getBoundingClientRect();
                this.editorHeight = cardRect.height - 135;
            }

            if (this.$refs.editor?.codemirror?.refresh) {
                this.$refs.editor.codemirror.refresh();
            }
        },
        doShowDialog() {
            this.showDialog = true;
        },
    },
    computed: {
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
        redirectDialogWidth() {
            return this.homepageFixHorizontalScrollEnabled ? '80%' : '80vw';
        }
    }
};
</script>

<style scoped>
.redirect-editor {
    width: 100%;
}
</style>
